import React from 'react';
import PropTypes from 'prop-types'; 
import { Plus } from 'lucide-react';

const AddButton = ({ onClick, text }) => {
    return (
        <button 
            onClick={onClick} 
            style={{
                width: '150px',
                height: '35px',
                padding: '4px 12px',
                gap: 'var(--2)',
                borderRadius: '60px ',
                border: '1px solid #DFE4EA',
                backgroundColor: 'white',
                opacity: '1', 
                cursor: 'pointer', 
                whiteSpace: 'nowrap'
            }}
        >
            <Plus width={"16px"} height={"16px"} style={{marginRight: "10px"}}/>
            {text}
        </button>
    );
};

AddButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired, 
};

export default AddButton;
